<template>
  <v-dialog v-model="dialog" max-width="520" :persistent="processing || downloading">
    <v-card>
      <v-card-title class="navy darken-1 white--text">
        <div>Elimina squadra definitivamente: </div>
        <div v-if="squadra" class="font-weight-bold ml-2">{{ squadra.name }}</div>
        <v-spacer />
        <v-btn icon class="white--text" :disabled="processing || downloading" aria-label="Chiudi" @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <template v-if="squadra">

          <v-alert type="error" text dense class="mb-2 ">
              La squadra verrá eliminata definitivamente. Un nuovo partecipante potrà iscriversi all'asta (tramite normale link di invito)
          </v-alert>

          <template v-if="numeroCalciatori > 0">
            <p>ATTENZIONE: La squadra che stai per eliminare aveva giá una rosa</p>
            <div class="d-flex justify-center">
              <v-btn outlined color="primary" :loading="downloading" :disabled="processing" @click="download">
                <v-icon left small>file_download</v-icon>
                Scarica Rosa
              </v-btn>
            </div>
            <p class="text-caption mt-2 mb-4">
              Perché scaricarne la rosa? Perché sará eliminata quando eliminerai la squadra. Ti sará quindi utile se vorrai riassegnarne manualmente i calciatori alla nuova squadra che si iscriverá (puoi farlo tramite la modalitá d'asta "Admin assegna").
            </p>
          </template>

        </template>


        <v-alert type="info" text dense class="mb-2 ">
           <div class="font-weight-bold">Puoi eliminare massimo {{Constants.MAX_ELIMINAZIONI_SQUADRE }} squadre in ciascuna asta.</div>
          <div v-if="!disabledReason" class="text-caption mt-1">
            <template v-if="disponibili === 1">
              Questa è l'ultima eliminazione disponibile per questa asta.
            </template>
            <template v-else-if="disponibili === 2">
              Dopo questa potrai eliminare ancora una squadra.
            </template>
            <template v-else>
              Dopo questa potrai eliminare ancora {{ disponibili - 1 }} squadre.
            </template>
          </div>
         </v-alert>

        <v-alert v-if="disabledReason || error" type="error" outlined dense class="mt-4 mb-0">
          {{ error || disabledReason }}
        </v-alert>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0 flex-wrap">
        <v-btn text :disabled="processing || downloading" @click="dialog = false">Annulla</v-btn>
        <v-spacer />
        <v-btn color="error" :loading="processing" :disabled="!!disabledReason || downloading" @click="elimina">
          Elimina definitivamente
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import * as Helpers from "../../js/helpers";
import { downloadWorkbook, squadraWorkbook } from "../../js/excel";
import Crediti from "../common/Crediti";

export default {
  name: "dialog-elimina-squadra",
  mixins: [mixins, toast],
  components: { Crediti },
  data() {
    return { dialog: false, squadraId: null, processing: false, downloading: false, error: "" };
  },
  mounted() {
    db.on("showDialogEliminaSquadra", this.open);
  },
  destroyed() {
    db.off("showDialogEliminaSquadra", this.open);
  },
  computed: {
    squadra() { return this.asta_squadre[this.squadraId]; },
    numeroCalciatori() { return Object.keys(this.squadra.calciatori || {}).length; },
    disponibili() { return Helpers.eliminazioniSquadreDisponibili(this.asta_info); },
    disabledReason() {
      return Helpers.eliminaSquadraDisabledReason(
        this.Config.STANDALONE, this.user_uid, this.asta_info,
        this.asta_round, this.squadraId, this.squadra
      );
    },
  },
  methods: {
    open(squadraId) {
      if (!this.Config.STANDALONE || !this.admin || this.processing) return;
      this.squadraId = squadraId;
      this.error = "";
      this.dialog = true;
    },
    async download() {
      if (!this.squadra || this.downloading) return;
      this.downloading = true;
      this.error = "";
      try {
        await downloadWorkbook(
          squadraWorkbook(this.squadra, this.calciatori),
          `Rosa ${this.squadra.name} - ${this.asta_info.name}`
        );
      } catch (error) {
        this.error = "Impossibile scaricare l'Excel. Riprova prima di eliminare la squadra.";
      } finally {
        this.downloading = false;
      }
    },
    async elimina() {
      if (this.disabledReason || this.processing || this.downloading) return;
      this.processing = true;
      this.error = "";
      const name = this.squadra.name;
      try {
        await db.eliminaSquadra(this.squadraId);
        this.dialog = false;
        this.successToast("Squadra eliminata", name);
      } catch (error) {
        this.error = error.code === "PERMISSION_DENIED"
          ? "Eliminazione non consentita. Verifica che l'asta sia ferma e che ci siano ancora eliminazioni disponibili."
          : error.message;
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
